export default __webpack_public_path__ + "static/media/john.deb2739e.jpeg";